<script setup lang="ts">
import CopyToClipboardButton from "~components/widgets/CopyToClipboardButton.vue"

defineProps<{
  title: string
  source: unknown
  maxHeight?: string
}>()
</script>

<template>
  <div class="p-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <strong>{{ title }}</strong>
      <copy-to-clipboard-button :source="source" size="sm" />
    </div>
    <pre
      class="bg-light p-2 rounded"
      :style="{
        maxHeight: maxHeight || '24em',
        overflow: 'auto',
      }"
    >{{ JSON.stringify(source, null, 2) }}</pre>
  </div>
</template>
